import "./guage.scss";
import getStyled from "../../hooks/getStyled";

const { theme } = getStyled();

const ProgressGuage = (props) => {
  let {
    size = 150,
    fontSize = "1.5em",
    progress = 0,
    trackWidth = 10,
    trackColor = "#ddd",
    indicatorWidth = 10,
    indicatorColor = theme.palette.blue200.main,
    indicatorCap = "round",
    label = "Loading...",
    labelColor = theme.palette.grey400.main,
    spinnerMode = false,
    spinnerSpeed = 1,
    showLabel = false,
  } = props;

  const center = size / 2,
    radius =
      center - (trackWidth > indicatorWidth ? trackWidth : indicatorWidth),
    dashArray = 2 * Math.PI * radius,
    dashOffset = dashArray * ((100 - progress) / 100);

  let hideLabel = size < 100 || !label.length || spinnerMode ? true : false;
  if (showLabel) hideLabel = false;

  return (
    <>
      <div className="svg-pi-wrapper" style={{ width: size, height: size }}>
        <svg className="svg-pi" style={{ width: size, height: size }}>
          <circle
            className="svg-pi-track"
            cx={center}
            cy={center}
            fill="transparent"
            r={radius}
            stroke={trackColor}
            strokeWidth={trackWidth}
          />
          <circle
            className={`svg-pi-indicator ${
              spinnerMode ? "svg-pi-indicator--spinner" : ""
            }`}
            style={{ animationDuration: spinnerSpeed * 1000 }}
            cx={center}
            cy={center}
            fill="transparent"
            r={radius}
            stroke={indicatorColor}
            strokeWidth={indicatorWidth}
            strokeDasharray={dashArray}
            strokeDashoffset={dashOffset}
            strokeLinecap={indicatorCap}
          />
        </svg>

        {!hideLabel && (
          <div className="svg-pi-label" style={{ color: labelColor }}>
            {!spinnerMode && (
              <span className="svg-pi-label__progress" style={{ fontSize }}>
                {`${progress > 100 ? 100 : progress}%`}
              </span>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default ProgressGuage;
